var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBookEdit = function SvgBookEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.75V5.25C5 4.65326 5.23047 4.08097 5.6407 3.65901C6.05094 3.23705 6.60734 3 7.1875 3H12.6562M5 18.75C5 19.3467 5.23047 19.919 5.6407 20.341C6.05094 20.7629 6.60734 21 7.1875 21H18.125C18.3571 21 18.5796 20.9052 18.7437 20.7364C18.9078 20.5676 19 20.3387 19 20.1V12M5 18.75C5 18.1533 5.23047 17.581 5.6407 17.159C6.05094 16.7371 6.60734 16.5 7.1875 16.5H19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.44 6.26414C20.7986 5.90555 21 5.41921 21 4.91209C21 4.40497 20.7986 3.91862 20.44 3.56004C20.0815 3.20145 19.5952 3 19.0881 3C18.581 3 18.0947 3.20145 17.7362 3.56004L13.2268 8.07167C13.0128 8.28557 12.8562 8.54996 12.7714 8.84041L12.018 11.4239C11.9954 11.5014 11.9941 11.5835 12.0141 11.6616C12.0341 11.7398 12.0748 11.8111 12.1318 11.8682C12.1889 11.9252 12.2602 11.9659 12.3383 11.9859C12.4165 12.0059 12.4986 12.0046 12.576 11.982L15.1593 11.2286C15.4497 11.1437 15.7141 10.9871 15.9279 10.7731L20.44 6.26414Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBookEdit);
export { ForwardRef as ReactComponent };